export const CAPTURES_CONFIG = {
  apartment: {
    key: "apartment",
    label: "Departamento"
  },
  address: {
    key: "address",
    label: "Domicilio"
  },
  meter: {
    key: "meter",
    label: "Medidor"
  },
  customer: {
    key: "customer",
    label: "Cliente"
  },
  captureDate: {
    key: "captureDate",
    label: "Fecha"
  },
  currentCapture: {
    key: "currentCapture",
    label: "Captura Anterior"
  },
  capture: {
    key: "capture",
    label: "Captura Actual"
  },
  motive: {
    key: "cancellationType",
    label: "Motivo de cancelación"
  },
  notes: {
    key: "note",
    label: "Notas"
  },
  help: {
    key: "supportType",
    label: "Ayuda"
  },
  total: {
    key: "total",
    label: "Consumo"
  },
  average: {
    key: "average",
    label: "Promedio Consumo"
  },
  status: {
    key: "status",
    label: "Estado"
  }
};

export const CAPTURES_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Capturas",
      header: {
        dropdown: {
          noOptions: "No se periodos de corte",
          label: "Periodos de Corte"
        },
        button: "Buscar",
        closeButton: "Cerrar Periodo",
        syncButton: "Sincronizar Periodo",
        snackBar: "Selecciona un Periodo de corte"
      },
      actions: {
        edit: "Editar Captura",
        cancel: "Cancelar Captura",
        image: "Mostrar Imagen"
      }
    }
  },
  modal: {
    titles: {
      edit: "Modificar Captura",
      add: "Agregar Nueva Captura",
      delete: "¿Estas seguro de eliminar esta captura?"
    },
    actions: {
      cancel: "Cancelar",
      close: "Cerrar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      submit: "Aceptar"
    },
    content: {
      cancel: "¿Estas seguro que desea cancelar esta captura?",
      close: "¿Estas seguro que desea cerrar el periodo?",
      image: "¿Estas seguro que ver la imagen?"
    },
    dropdown: {
      label: "Motivo de cancelación"
    }
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
      cancelCapture: "Captura cancelada.",
      closeCapture: "Captura cerrada.",
      noImage: "No hay imagen para esta captura."
    }
  },
  form: {
    dropdowns: {
      client: "Seleccione un Cliente",
      apartment: "Seleccione un Departamento",
      status: "Seleccione un Estado"
    }
  }
};
